import { useContext } from 'react';
import TableSettingsContext from 'contexts/TableSettingsContext';

/**
 * Stack Your Active Tables, as both settings menus show it: the in-table menu
 * (TableMenuPanel) and the account menu (AccountMenuPanel). One definition, so
 * the two can't drift — the same label, description, value and setter, the way
 * TableViewSizeControl is shared. Each menu renders it with its own row.
 *
 * A setting for every view and every table, not one table's: it decides
 * whether the header shows each open table or one stacked switcher, in single
 * view and in the grid alike.
 */
export const useStackTablesToggle = () => {
  const { stackTables, setStackTables } = useContext(TableSettingsContext);
  return {
    label: 'Stack Your Active Tables',
    description: 'On: collapse open tables into one switcher. Off: show every open table.',
    checked: stackTables,
    onChange: setStackTables
  };
};
